module.exports = __webpack_public_path__ + "static/assets/e87c00e4a04a98769531e2645aecd8b7.png";